import { InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';

const useStyles = makeStyles(() => ({
  label: {
    fontSize: '13px',
    lineHeight: '17px',
  },
}));

interface LabelProps extends PropsWithChildren<unknown> {
  'data-test'?: string;
  className?: string;
  style?: React.CSSProperties;
}

const Label: React.FC<LabelProps> = ({ className, children, style, 'data-test': dataTest }) => {
  const classes = useStyles();
  return (
    <InputLabel filled className={clsx(classes.label, className)} style={style} data-test={dataTest}>
      {children}
    </InputLabel>
  );
};

export default Label;
